import React from 'react';

import { useCommonStyles, makeMuiStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  iconButton: {
    ...common.textPrimary,
    ...common.middleText,
    display: 'inline-flex',
    alignItems: 'center',
    '&:hover': {
      opacity: 0.5,
    },
    '&:disabled': {
      opacity: 0.5,
    },
  },
}));

export interface IconButtonProps
  extends Omit<React.HTMLProps<HTMLButtonElement>, 'color' | 'size'> {
  icon: React.ReactNode;
  text: React.ReactNode;
}

export const IconButton: React.FC<IconButtonProps> = (props) => {
  const { icon, text, ...rest } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <button {...(rest as any)} className={classes.iconButton}>
      {icon}
      <span style={{ width: 4 }} />
      {text}
    </button>
  );
};
